import { useQuery } from '@tanstack/react-query'
import { bomCapturaApi } from '@/services/api'

/** Catálogo de variantes con características (para 'copiar de otra versión'). Se carga
 *  bajo demanda (`enabled`, al abrir el selector) y se cachea; el buscador va en cliente. */
export function useCatalogoCaracteristicas(enabled: boolean) {
  const { data, isLoading, isError, error } = useQuery({
    queryKey: ['bom-catalogo-caracteristicas'],
    queryFn: () => bomCapturaApi.getCatalogoCaracteristicas(),
    enabled,
    staleTime: 5 * 60 * 1000,
  })
  return { variantes: data?.data ?? [], loading: isLoading, isError, error }
}
